import { Box, Card, Grid, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { MANDATORY_FIELD_ERR } from '../../../constants';
import { emplomentStyles as classes } from '../Employment/EmploymentStyles';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { ProductUIStyles } from '../StepTwo/ProductUIStyles';

const CustomTextCard = ({ cardList, handleCardClick, errorMessage, productDataIRA }) => {
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { t } = useTranslation();
  const styledClasses = ProductUIStyles(leadGenerationContext?.theme);
  const { theme } = leadGenerationContext;

  const StyledCard = styled(Card)(({ isActive, disabled }) => ({
    borderRadius: '6px',
    backgroundColor: theme?.palette?.fieldsBackground?.main,
    border: `1px solid ${theme?.palette?.fieldsBorder?.main}`,
    color: theme?.palette?.primary?.main,

    cursor: 'pointer',
    transition: 'all 0.3s ease',
    height: '52px',

    maxWidth: '136px',
    padding: '0 10px',
    textAlign: 'center',

    ...(isActive && {
      border: `2px solid ${theme?.palette?.orientalPrimary?.main}`,
      backgroundColor: theme?.palette?.cardActiveBackground?.main,
      color: theme?.palette?.primary?.main,
    }),
    ...(disabled && {
      border: `2px solid ${theme?.palette?.disabled?.main}`,
      backgroundColor: theme?.palette?.disabledButtonBackground?.main,
      color: theme?.palette?.disabled?.main,
      pointerEvents: 'none',
    }),
  }));
  return (
    <>
      <Grid container spacing={2} sx={{ width: '100%' }}>
        {cardList?.map((item) => (
          <Grid key={item.text}>
            <StyledCard
              tabIndex="0"
              variant="outlined"
              onClick={(e) => handleCardClick(e, item)}
              disabled={item?.disabled}
              data-testid="employmentStatus_testid"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleCardClick(e, item);
                }
              }}
              aria-label={
                productDataIRA?.yearStatus?.text === item.text ? `${item.text} selected` : item.text
              }
              isActive={productDataIRA?.yearStatus?.text === item.text}
            >
              <Box component="div" sx={classes.employmentcardcontent}>
                {t('tax year', { year: item?.text?.split(' ')[0] })}
              </Box>
            </StyledCard>
          </Grid>
        ))}
      </Grid>
      <Box
        component="span"
        sx={styledClasses.error_message_product}
        role="alert"
        data-testid="employmentStatus_errid"
      >
        {t(errorMessage, {
          defaultValue: errorMessage,
        })}
      </Box>
    </>
  );
};

export default CustomTextCard;

CustomTextCard.propTypes = {
  cardList: PropTypes.object,
  productDataIRA: PropTypes.object,
  handleCardClick: PropTypes.func,
  errorMessage: PropTypes.string,
};
